document.addEventListener("DOMContentLoaded", function () {
    // Check if any pricing box sections exist on the page
    const pricingSections = document.querySelectorAll('.section-pricing-box-block');
    
    // If no pricing sections found, exit early
    if (pricingSections.length === 0) {
        return;
    }
    
    // Define icons once for all sections
    const showIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M5 8L10 13L15 8" stroke="white" stroke-width="2" stroke-linecap="round"/>
      <path d="M0 10C6.04674e-08 8.61667 0.2625 7.31667 0.787501 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 -6.04529e-08 10 0C11.3833 6.0482e-08 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 -6.04674e-08 11.3833 0 10ZM2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10Z" fill="white"/>
    </svg>
    `;

    const hideIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M15 12L10 7L5 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
      <path d="M20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.787501 13.9C0.262501 12.6833 7.53293e-07 11.3833 8.74228e-07 10C9.95163e-07 8.61667 0.262502 7.31666 0.787502 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.787499C7.31667 0.2625 8.61667 -9.95163e-07 10 -8.74228e-07C11.3833 -7.53293e-07 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10ZM18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76666 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10Z" fill="white"/>
    </svg>
    `;

    function isDesktop() {
        return window.innerWidth >= 768;
    }

    // Process each pricing section independently
    pricingSections.forEach((section, sectionIndex) => {
        const toggleWrappers = section.querySelectorAll('.js-pricing-toggle');
        const extraTile = section.querySelector('.section-pricing-box-block__extra-tile');
        const wrappers = section.querySelectorAll('.js-section-pricing-box-block__wrapper');
        
        // Skip this section if it doesn't have the required elements
        if (toggleWrappers.length === 0 || !extraTile || wrappers.length === 0) {
            return;
        }
        
        const logoDesktop = extraTile.querySelector('.section-pricing-box-block__extra-tile-logo-desktop');
        const logoImg = extraTile.querySelector('.section-pricing-box-block__extra-tile-logo img');
        const originalParent = extraTile.parentElement;
        
        // Track active toggle for this section
        let activeToggle = null;

        if (wrappers.length % 2 !== 0) {
            extraTile.classList.add('col-12', 'col-lg-5', 'active');

            // Set width based on screen size
            function setExtraTileWidth() {
                if (isDesktop()) {
                    extraTile.style.width = '41.66666667%'; // 5/12
                } else {
                    extraTile.style.width = '100%';
                }
            }

            // Set initially
            setExtraTileWidth();

            // Update on resize
            window.addEventListener('resize', setExtraTileWidth);
        }

        // Initialize each toggle wrapper in this section
        toggleWrappers.forEach((wrapper, index) => {
            const button = wrapper.querySelector('.section-pricing-box-block__toggle-button');
            const details = wrapper.querySelector('.section-pricing-box-block__details');
            
            // Skip if button or details are missing
            if (!button || !details) {
                return;
            }
            
            const showLabel = button.getAttribute('data-show-label') || 'Show';
            const hideLabel = button.getAttribute('data-hide-label') || 'Hide';

            details.classList.remove('is-visible');
            details.classList.add('is-hidden');
            button.innerHTML = `${showIcon} ${showLabel}`;

            button.addEventListener('click', function () {
                const even = wrappers.length % 2 === 0;
                const isSameToggle = activeToggle === wrapper;

                // Reset all toggles in this section
                toggleWrappers.forEach(w => {
                    const d = w.querySelector('.section-pricing-box-block__details');
                    const b = w.querySelector('.section-pricing-box-block__toggle-button');
                    if (d && b) {
                        const sLabel = b.getAttribute('data-show-label') || 'Show';
                        d.classList.remove('is-visible');
                        d.classList.add('is-hidden');
                        b.innerHTML = `${showIcon} ${sLabel}`;
                    }
                });

                if (isSameToggle) {
                    activeToggle = null;
                    originalParent.appendChild(extraTile);
                    if (even) {
                        extraTile.classList.remove('active');
                    }
                    if (isDesktop() && even && logoImg) {
                        logoImg.style.display = 'none';
                    }
                    return;
                }

                details.classList.remove('is-hidden');
                details.classList.add('is-visible');
                button.innerHTML = `${hideIcon} ${hideLabel}`;
                activeToggle = wrapper;
                extraTile.classList.remove('active');
                
                if (logoImg) logoImg.style.display = 'none';
                if (logoDesktop) logoDesktop.classList.add('is-hidden');

                if (isDesktop()) {
                    if (even) {
                        if (index === 0) {
                            wrappers[wrappers.length - 1].appendChild(extraTile);
                        } else if (index === wrappers.length - 1) {
                            wrappers[wrappers.length - 2].appendChild(extraTile);
                        } else {
                            wrappers[index].appendChild(extraTile);
                        }
                    } else {
                        originalParent.appendChild(extraTile);
                    }

                    extraTile.classList.add('active');
                    if (logoImg) logoImg.style.display = 'block';
                    if (logoDesktop && even) logoDesktop.classList.remove('is-visible');
                } else {
                    originalParent.appendChild(extraTile);
                    if (logoImg) logoImg.style.display = 'block';
                    if (logoDesktop && even) logoDesktop.classList.remove('is-visible');
                }
            });
        });
    });
});